import { FC, useState } from 'react';
import { BackIcon } from 'assets/icons';
import { CustomButton } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import ExpiryDateSection from './ExpiryDateSection';

interface EditExpiryDatePanelProps {
  selectedDate: Date;
  onBackClick: () => void;
  onSave: (date: Date) => void;
  isActionInProgress: boolean;
}

const EditExpiryDatePanel: FC<EditExpiryDatePanelProps> = ({
  selectedDate,
  onBackClick,
  onSave,
  isActionInProgress
}) => {
  const [tempSelectedDate, setTempSelectedDate] = useState<Date>(selectedDate);
  const [showCustomPicker, setShowCustomPicker] = useState(false);

  const handleSave = () => {
    onSave(tempSelectedDate);
  };

  const handleBackClick = () => {
    if (showCustomPicker) {
      setShowCustomPicker(false);
    } else {
      onBackClick();
    }
  };

  return (
    <div className="h-full w-96">
      <div className="flex items-center border-b border-secondaryBtn py-4">
        <BackIcon className="mx-4 cursor-pointer" id="expiry-date-panel-back-arrow" onClick={handleBackClick} />
        <div className="text-17px font-semibold text-headingGray">
          {showCustomPicker ? 'Choose date' : 'Expires on'}
        </div>
      </div>

      <div className="py-6 px-4">
        <ExpiryDateSection
          selectedDate={tempSelectedDate}
          onDateChange={setTempSelectedDate}
          showCustomPicker={showCustomPicker}
          onCustomPickerChange={setShowCustomPicker}
        />
      </div>

      <div className="flex w-full flex-col gap-y-4 p-4 pt-0">
        <CustomButton
          id="edit-expiry-date-save-button"
          className="w-full"
          onClick={handleSave}
          type={ButtonType.PRIMARY}
          disabled={selectedDate.getTime() === tempSelectedDate.getTime()}
          isLoading={isActionInProgress}>
          Save
        </CustomButton>
        <CustomButton
          id="edit-expiry-date-cancel-button"
          className="w-full"
          onClick={onBackClick}
          type={ButtonType.SECONDARY}>
          Cancel
        </CustomButton>
      </div>
    </div>
  );
};

export default EditExpiryDatePanel;
